import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, AwardIcon, UsersIcon, HeartHandshakeIcon } from 'lucide-react';
import { useLanguage } from '../lib/i18n';
export function AboutSection() {
  const {
    t
  } = useLanguage();
  const features = [{
    icon: ShieldCheckIcon,
    titleKey: 'about.feature1Title',
    descKey: 'about.feature1Desc'
  }, {
    icon: AwardIcon,
    titleKey: 'about.feature2Title',
    descKey: 'about.feature2Desc'
  }, {
    icon: UsersIcon,
    titleKey: 'about.feature3Title',
    descKey: 'about.feature3Desc'
  }, {
    icon: HeartHandshakeIcon,
    titleKey: 'about.feature4Title',
    descKey: 'about.feature4Desc'
  }];
  return <section id="o-nas" className="py-24 md:py-32 bg-[#111111]" data-id="element-14">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-15">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-16">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-17">
            <span className="text-[#c8a96e] text-sm font-semibold tracking-widest uppercase mb-4 block" data-id="element-18">
              {t('about.sectionLabel')}
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-19">
              {t('about.title')}
            </h2>
            <p className="text-[#a3a3a3] text-lg leading-relaxed mb-8" data-id="element-20">
              {t('about.description')}
            </p>
            <p className="text-[#737373] leading-relaxed" data-id="element-21">
              {t('about.description2')}
            </p>
          </motion.div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-22">
            {features.map((feature, index) => <motion.div key={feature.titleKey} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-[#1c1c1c] border border-[#2a2a2a] rounded-xl p-6 hover:border-[#c8a96e]/30 transition-colors duration-300" data-id="element-23">
                <div className="w-12 h-12 bg-[#c8a96e]/10 rounded-lg flex items-center justify-center mb-4" data-id="element-24">
                  <feature.icon className="w-6 h-6 text-[#c8a96e]" data-id="element-25" />
                </div>
                <h3 className="text-white font-semibold mb-2" data-id="element-26">
                  {t(feature.titleKey)}
                </h3>
                <p className="text-[#737373] text-sm leading-relaxed" data-id="element-27">
                  {t(feature.descKey)}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}